/** Pagination metadata from list APIs. */
export interface ListModulePaginationMeta {
  total: number;
  lastPage: number;
  currentPage: number;
  perPage: number;
}

/** Filter values owned by the parent page and passed into the toolbar. */
export interface ListModuleFilters {
  searchQuery: string;
  status: string;
  dateRange: string;
  dateRangeStart: string;
  dateRangeEnd: string;
}

export const DEFAULT_LIST_MODULE_FILTERS: ListModuleFilters = {
  searchQuery: '',
  status: '',
  dateRange: '',
  dateRangeStart: '',
  dateRangeEnd: '',
};

export interface ListModuleStatusOption {
  value: string;
  label: string;
}

/** `false` disables a filter; an object (or `true`) enables it with optional overrides. */
export type ListModuleSearchConfig =
  | false
  | true
  | {
      placeholder?: string;
      deletedPlaceholder?: string;
      debounceMs?: number;
    };

export type ListModuleStatusFilterConfig =
  | false
  | true
  | {
      label?: string;
      options?: ListModuleStatusOption[];
    };

export type ListModuleDateRangeConfig =
  | false
  | true
  | {
      placeholder?: string;
      deletedPlaceholder?: string;
    };

export type ListModulePaginationConfig = false | true | { enabled?: boolean };

/**
 * Per-page toolbar configuration. Omit a key or set it to `false` to hide that filter.
 *
 * @example
 * toolbarConfig = {
 *   search: { placeholder: 'Search users…' },
 *   status: { options: [{ value: 'Active', label: 'Active' }] },
 *   dateRange: true,
 * };
 */
export interface ListModuleToolbarConfig {
  search?: ListModuleSearchConfig;
  status?: ListModuleStatusFilterConfig;
  dateRange?: ListModuleDateRangeConfig;
}

export interface ListModuleSurfaceConfig {
  toolbar?: ListModuleToolbarConfig;
  pagination?: ListModulePaginationConfig;
}

export function listModuleFilterEnabled(
  config: ListModuleSearchConfig | ListModuleStatusFilterConfig | ListModuleDateRangeConfig | undefined,
): boolean {
  return config !== false && config !== undefined;
}

export function listModulePaginationEnabled(
  config: ListModulePaginationConfig | undefined,
): boolean {
  return config === true || (typeof config === 'object' && config.enabled !== false);
}
